import * as types from '@/store/mutation-types'

export default {
    namespaced: true,
    state: {
        employeeStock: []
    },
    actions: {
        fetchEmployeeStock ({ commit }, { fromDate, toDate, isPosted, isDifferent, note, employeeIds }) {
            const urlSearchParams = new URLSearchParams()
            const params = { fromDate, toDate, isPosted, isDifferent, note }
            employeeIds.forEach(employeeId => { urlSearchParams.append('employeeIds', employeeId) })
            Object.keys(params).forEach((param) => {
                if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
            })
            return window.axios.get('/EmployeeStock/search', { params: urlSearchParams }).then(({ data }) => {
                commit(types.STORE_EMPLOYEE_STOCK, data)
                return data
            })
        },

        create ({ commit }, { employeeId, date, amountDelivered, amountReceived, notes, isPosted }) { 
            return window.axios.post('/employeeStock', 
                { employeeId, date, amountDelivered, amountReceived, notes, isPosted }).then(({ data }) => {
                return data
            })
        },

        update ({ commit }, { id, employeeId, date, amountDelivered, amountReceived, notes, isPosted }) {
            return window.axios.put(`/employeeStock/${id}`, 
                { employeeId, date, amountDelivered, amountReceived, notes, isPosted }).then(({ data }) => {
                return data
            })
        },

        delete ({ commit }, { id }) {
            return window.axios.delete(`/employeeStock/${id}`)
        },

        posted ({ commit }, { id }) {
            return window.axios.put(`/employeeStock/post/${id}`).then(({ data }) => {
                return data
            })
        }
    },
    mutations: {
        [types.STORE_EMPLOYEE_STOCK] (state, employeeStock) {
            state.employeeStock = employeeStock
        }
    },
    getters: {}
}